import React from "react";
import PropTypes from "prop-types";
import AutoReportDownloadModalContainer from "../AutoReportDownloadModal/container";
import TopBarContainer from "../TopBar/container";
import PageTransition from "../PageTransition";

import SearchProvider from "../SearchProvider";
import ReportNav from "../ReportNav";
import ModalRootContainer from "../ModalRoot/container";
import CookieMessageContainer from "../CookieMessage/container.js";

import "./index.css";
import styles from "./index.module.css";

export class Root extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      triggerOnboarding: false
    };
    this.closeOnboarding = this.closeOnboarding.bind(this);
    this.openOnboarding = this.openOnboarding.bind(this);
  }

  componentDidMount() {
    const script = document.createElement(`script`);

    script.src = `https://public.flourish.studio/resources/embed.js`;
    script.async = true;

    document.body.appendChild(script);
  }

  componentDidUpdate() {
    const script = document.createElement(`script`);

    script.src = `https://public.flourish.studio/resources/embed.js`;
    script.async = true;

    document.body.appendChild(script);
  }

  closeOnboarding() {
    this.setState({ triggerOnboarding: false });
  }

  openOnboarding() {
    this.setState({ triggerOnboarding: true });
  }

  render() {
    const { children, location } = this.props;
    // Standalone pages, don't need no layout
    if (
      location.pathname.startsWith(`/chart/`) ||
      location.pathname.startsWith(`/content-overview`) ||
      location.pathname.startsWith(`/article/`)
    )
      return children;

    // Standard layout
    return (
      <React.Fragment>
        <AutoReportDownloadModalContainer />
        <SearchProvider>
          <div className={styles.topBarContainer}>
            <TopBarContainer
              toggleOnboarding={this.openOnboarding}
              location={location}
            />
          </div>
          <div className={styles.content}>
            <ReportNav location={location} />
            <PageTransition location={location}>{children}</PageTransition>
          </div>
        </SearchProvider>
        <ModalRootContainer />
        <CookieMessageContainer />
      </React.Fragment>
    );
  }
}

Root.propTypes = {
  location: PropTypes.object
};

export default Root;
